export default {
    index: {
        title: "Home",
        keywords: "JX3,JX3BOX,tools,guides,news,community",
        description: "JX3BOX home: news, community updates, and world bulletin.",
    },
    notice: {
        title: "Notice Center",
        keywords: "notice,news,updates,events,redemption,JX3BOX",
        description: "Notice Center: browse notices, events, updates, and redemption announcements from JX3BOX.",
        single: {
            title: "Notice Details",
            keywords: "notice details,notice,news,JX3BOX",
            description: "Notice details: read full content and view update info and engagement stats.",
        },
    },
};
